import React from 'react';
import { Layout } from 'tea-component';
import CardCommon from '../../components/CardCommon';
import useLanguage from '../../hooks/useLanguage';
import './index.scss';

const { Content } = Layout;

const NotFound: React.FC = () => {
  const { formatMessage } = useLanguage();

  return (
    <Content className="dbo-page not-found-wrapper">
      <Content.Body>
        <CardCommon
          emptyHeight={760}
          empty
          hasEmptyTitle={true}
          emptyTitleText={formatMessage('Unrecognized Link')}
          emptyDescText={formatMessage("The system doesn't recognize the format of the link you entered. Please verify the link and try again.")}
        />
      </Content.Body>
    </Content>
  );
};

export default NotFound;
